export default {"src":"/_next/static/media/PlanterIcon.9648a82d.svg","height":75,"width":124};